import React from "react";
import { Outlet } from "react-router-dom";
import Sidenav from "../dashboard/SideNav";
import ExtraInfo from "../dashboard/components/ExtraInfo";
import "../dashboard/dashboardStyle.css";

const DashboardLayout = () => {
  return (
    <div>
      <Sidenav />
      <div className="main-content-wrapper">
        <div className="left"></div>
        <div className="right">
        <div className="page-content px-lg-5 container">
          <Outlet />
        </div>
        <div className="dashboard-footer py-3 mt-4">
          <p className="text-center mb-0">© Poll Sphere Tool</p>
        </div>
        </div>
      </div>
      <ExtraInfo />
    </div>
  );
};

export default DashboardLayout;
